export const joinNonEmpty = (
  parts: (string | undefined)[],
  separator: string
) => parts.filter(Boolean).join(separator);
